<template>
    <v-card
        v-if="visible"
        :loading="loading"
        :disabled="loading"
    >
        <v-card-title>{{ title }}</v-card-title>
        <v-card-subtitle>
            Ukom Nakes akan memberikan pembahasan video sesuai jawaban kamu
        </v-card-subtitle>

        <v-card-text>
            <v-window v-model="window">
                <v-window-item>
                    <v-rating
                        @input="rated"
                        v-model="rating"
                    ></v-rating>
                </v-window-item>

                <v-window-item>
                    <v-checkbox
                        v-model="explanations"
                        label="Video"
                        value="video"
                    ></v-checkbox>

                    <v-checkbox
                        v-model="explanations"
                        label="Slide Gambar"
                        value="slide"
                    ></v-checkbox>

                    <v-checkbox
                        v-model="explanations"
                        label="File PDF"
                        value="pdf"
                    ></v-checkbox>

                    <v-checkbox
                        v-model="other"
                        label="Lainnya"
                    ></v-checkbox>

                    <v-text-field
                        v-if="other"
                        v-model="otherText"
                        label="Pembahasan lainnya"
                    ></v-text-field>

                    <v-btn
                        @click="sendExplanations"
                        color="primary"
                        :disabled="
                            explanations.length == 0 && otherText == null
                        "
                    >
                        Kirim
                    </v-btn>
                </v-window-item>

                <v-window-item>
                    <v-textarea
                        v-model="description"
                        label="Apakah kamu punya pendapat lain tentang pembahasan video atau aplikasi tryout Mediko.id?"
                    ></v-textarea>

                    <v-btn
                        @click="sendDescription"
                        color="primary"
                        :disabled="description == ''"
                    >
                        Kirim
                    </v-btn>
                </v-window-item>

                <v-window-item>
                    <v-list-item>
                        <v-list-item-avatar>
                            <v-icon>mdi-thumb-up</v-icon>
                        </v-list-item-avatar>

                        <v-list-item-content>
                            <v-list-item-title>
                                Terima kasih telah mengisi survey ini
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-window-item>
            </v-window>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    data: () => ({
        loading: false,
        window: 0,
        rating: null,
        explanations: [],
        other: false,
        otherText: null,
        description: '',
        visible: false,
    }),

    computed: {
        title() {
            switch (this.window) {
                case 0:
                    return 'Bagaimana pendapatmu tentang pembahasan video?'
                case 1:
                    return 'Pembahasan mana yang lebih kamu suka?'
                case 2:
                    return 'Apakah kamu ada pendapat lain?'
                case 3:
                    return 'Terima Kasih :)'
                default:
                    return ''
            }
        },
    },

    methods: {
        async rated() {
            this.loading = true
            await this.$apiv2.post('video-survey/rating', {
                rating: this.rating,
            })
            this.loading = false

            this.window = 1
        },

        async sendExplanations() {
            const explanations = this.explanations

            if (this.otherText) {
                explanations.push(this.otherText)
            }

            this.loading = true
            await this.$apiv2.post('video-survey/explanation', {
                explanations,
            })
            this.loading = false

            this.window = 2
        },

        async sendDescription() {
            this.loading = true
            await this.$apiv2.post('video-survey/description', {
                description: this.description,
            })
            this.loading = false

            this.window = 3
        },
    },

    async created() {
        const response = await this.$apiv2.get('video-survey/status')

        if (response.data) {
            if (response.data.description) {
                return
            }

            if (response.data.explanations) {
                this.window = 2
            } else if (response.data.rating) {
                this.window = 1
            }
        }

        this.visible = true
    },
}
</script>
